import React from 'react';
import CalMonthSummary from './CalMonthSummary';

const CalWeekMonthHeader = ({ monthSpans, laneWidth, monthSummaryMap }) => {
    return (
        <div
            className="uiCalWeekMonthHeader"
            style={{
                position: 'relative',
                height: '54px',
                borderBottom: '1px solid #d7dfea',
                background: '#eef3f9'
            }}
        >
            {monthSpans.map((month) => {
                const monthSummary = monthSummaryMap?.[month.monthKey] || null;

                return (
                <div
                    key={month.monthKey}
                    style={{
                        position: 'absolute',
                        left: `${month.startIndex * laneWidth}px`,
                        width: `${month.weekCount * laneWidth}px`,
                        height: '54px',
                        padding: '8px 12px',
                        background: month.isCurrentMonth ? '#dde8f7' : '#eef3f9',
                        borderRight: '1px solid #d7dfea',
                        borderLeft: month.startIndex === 0 ? '1px solid #d7dfea' : '0',
                        boxSizing: 'border-box',
                        color: '#2a3f5f',
                        overflow: 'hidden'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            height: '100%',
                            justifyContent: 'flex-start'
                        }}
                    >
                        <div
                            style={{
                                fontWeight: 700,
                                fontSize: '14px',
                                lineHeight: '18px',
                                whiteSpace: 'nowrap',
                                flex: '0 0 auto'
                            }}
                        >
                            {month.monthLabel}
                        </div>
                        <CalMonthSummary month={month} monthSummary={monthSummary} />
                    </div>
                </div>
                );
            })}
        </div>
    );
};

export default CalWeekMonthHeader;
